import {FRIENDS_AND_FAMILY_CUG_TYPE} from './privateDeals'

/**
 * Gets the friend and family CUG type based on employee status.
 * @param isEmployee - Whether the user is an employee
 * @returns Array containing the friends and family CUG type if employee, empty array otherwise
 */
export const getFriendAndFamilyCugType = (isEmployee: boolean) =>
  isEmployee ? [FRIENDS_AND_FAMILY_CUG_TYPE] : []
